import { FC, useState, useEffect, useMemo } from "react"
import { useIntl } from "react-intl"
import { PageTitle } from "../../../smallnation/layout/core"
import { TablesWidget10 } from "../../../smallnation/partials/widgets"
import { ErrorMessage } from "@hookform/error-message";
import { useLocation, useHistory } from "react-router-dom";

//import { useForm } from "react-hookform";
import { useForm } from "react-hook-form";
import services from "../../modules/services/services";
//import $, { parseJSON } from 'jquery';
import $ from 'jquery';
//import { useNavigate } from 'react-router-dom';
/*
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
*/
//import { CKEditor } from '@ckeditor/ckeditor5-react';
//import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import SunEditor, { buttonList } from "suneditor-react";
import 'suneditor/dist/css/suneditor.min.css';
//import css from "../../../smallnation/assets/custom.css";
import UsNumberValidate from "../../modules/utility/usNumberValidate"

const CreateCompany: FC = () => {
  const intl = useIntl();
  const [categories, setCategory] = useState([]);
  const [locationCounty, setLocationCounty] = useState([]);
  const [stateData, setStateData] = useState([]);
  const [companyProf, setCompanyProfile] = useState("");
  let history = useHistory();
  const red = "red";

  const {
    register,
    formState: { errors },
    handleSubmit
  } = useForm({
    criteriaMode: "all", mode: "onBlur"
  });

  function validateCheck() {
    const checked = $('input[name="categorylist"]:checked').length;
    //alert(checked);
    if (checked >= 3) {
      $('input[name="categorylist"]').not(':checked').prop('disabled', true);
    } else {
      $('input[name="categorylist"]').prop('disabled', false);
    }
  }

  function handleChangeCompanyProfileDesc(content) {
    setCompanyProfile(content);
  }


  function handleImageUploadBefore(files: any, info: object, uploadHandler: Function) {
    var reader1 = new FileReader();
    reader1.readAsDataURL(files[0]);
    reader1.onload = function () {
      var rdt1: any = reader1.result;
      var base64result_banner = rdt1.split(',')[1];
      var bname = files[0].name;
      var bextn = bname.split(".").pop();
      var bannerActName = bname.split(".")[0];
      var fileext_banner = bextn;

      const requestObject = {
        //"imageName": files[0].name,
        "imageName": bannerActName,
        "imageExtension": fileext_banner,
        "imageByteString": base64result_banner
      };
      const requestOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          //'Authorization': "Bearer "+accessTokenIn 
          //'Authorization': accessTokenIn 
        },
        body: JSON.stringify(requestObject)
      };

      services.fileUploadS3URL(requestOptions).then((res) => {
        const response = {
          // The response must have a "result" array.
          "result": [
            {
              "url": res.url,
              "temp": files[0],
              "name": bannerActName,
              "size": files[0].size
            },
          ]
        }
        uploadHandler(response);

      });
    };

  }

  const submitValue = () => {
    //alert('submit');
    var categoriesArray: any = [];

    $.each($("input[name='categorylist']:checked"), function () {
      categoriesArray.push($(this).val());
    });

    var password_regex = /^(?=.*\d)(?=.*[!@#$%^&*])(?=.*[a-z])(?=.*[A-Z]).{8,}$/;
    var email_regex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
    // var website_regex = /^https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)/;
    var website_regex = /^(http(s)?:\/\/)[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.]+$/;
    var zip_regex = /^[\d./-]+$/;
    var validateEditorTxt = 1;
    if ($('#approval_status').val() == "") {
      $("#companystatusValidMsg").show();
      $(window).scrollTop($('#companystatusValidMsg').position().top);
      validateEditorTxt = 0;
    } else {
      $("#companystatusValidMsg").hide();
    }

    if ($('#first_name').val() == "") {
      $("#firstNameValidMsg").show();
      $(window).scrollTop($('#firstNameValidMsg').position().top);
      validateEditorTxt = 0;
    } else {
      $("#firstNameValidMsg").hide();
    }

    if ($('#last_name').val() == "") {
      $("#lastNameValidMsg").show();
      $(window).scrollTop($('#lastNameValidMsg').position().top);
      validateEditorTxt = 0;
    } else {
      $("#lastNameValidMsg").hide();
    }
    var password: any = $('#password').val();
    //alert(password);
    if (password == "") {
      $("#passwordReqMsg").show();
      $(window).scrollTop($('#passwordReqMsg').position().top);
      validateEditorTxt = 0;
    } else {
      $("#passwordReqMsg").hide();
    }

    if (password != "" && password_regex.test(password) == false) {
      $("#passwordValidMsg").show();
      $(window).scrollTop($('#passwordValidMsg').position().top);
      validateEditorTxt = 0;
    } else {
      $("#passwordValidMsg").hide();
    }


    var conf_password: any = $('#conf_password').val();
    if (conf_password == "") {
      $("#confpasswrdreqMsg").show();
      $(window).scrollTop($('#confpasswrdreqMsg').position().top);
      validateEditorTxt = 0;
    } else {
      $("#confpasswrdreqMsg").hide();
    }

    if (conf_password != "" && password_regex.test(conf_password) == false) {
      $("#confpasswordValidMsg").show();
      $(window).scrollTop($('#confpasswordValidMsg').position().top);
      validateEditorTxt = 0;
    } else {
      $("#confpasswordValidMsg").hide();
    }

    if (conf_password != password) {
      $("#matchValidMsg").show();
      $(window).scrollTop($('#matchValidMsg').position().top);
      validateEditorTxt = 0;
    } else {
      $("#matchValidMsg").hide();
    }
    var email_id: any = $('#email_id').val();
    if (email_id == "") {
      $("#emailReqMsg").show();
      $(window).scrollTop($('#emailReqMsg').position().top);
      validateEditorTxt = 0;
    } else {
      $("#emailReqMsg").hide();
    }

    if (email_id != "" && email_regex.test(email_id) == false) {
      $("#emailValidMsg").show();
      $(window).scrollTop($('#emailValidMsg').position().top);
      validateEditorTxt = 0;
    } else {
      $("#emailValidMsg").hide();
    }

    if ($('#company_name').val() == "") {
      $("#companyNameValidMsg").show();
      $(window).scrollTop($('#companyNameValidMsg').position().top);
      validateEditorTxt = 0;
    } else {
      $("#companyNameValidMsg").hide();
    }

    if ($('#address_1').val() == "") {
      $("#addressValidMsg").show();
      $(window).scrollTop($('#addressValidMsg').position().top);
      validateEditorTxt = 0;
    } else {
      $("#addressValidMsg").hide();
    }

    if ($('#city').val() == "") {
      $("#cityValidMsg").show();
      $(window).scrollTop($('#cityValidMsg').position().top);
      validateEditorTxt = 0;
    } else {
      $("#cityValidMsg").hide();
    }

    if ($('#state').val() == "") {
      $("#stateValidMsg").show();
      $(window).scrollTop($('#stateValidMsg').position().top);
      validateEditorTxt = 0;
    } else {
      $("#stateValidMsg").hide();
    }
    var zipcode: any = $('#postalcode').val();
    if (zipcode == "" || zip_regex.test(zipcode) == false) {
      $("#zipcodeValidMsg").show();
      $(window).scrollTop($('#zipcodeValidMsg').position().top);
      validateEditorTxt = 0;
    } else {
      $("#zipcodeValidMsg").hide();
    }
    /* if($('#country').val() == ""){
       $("#countyValidMsg").show();  
         $(window).scrollTop($('#countyValidMsg').position().top);
       validateEditorTxt = 0;     
     }else{
       $("#countyValidMsg").hide();  
     }     
     */
    if ($('#phone_number').val() == "") {
      $('#phonevalidmsg').show();
      $(window).scrollTop($('#phonevalidmsg').position().top);
      validateEditorTxt = 0;
    }
    else {
      $('#phonevalidmsg').hide();
    }

    if ($('#noofemp').val() == "") {
      $("#noofempValidMsg").show();
      $(window).scrollTop($('#noofempValidMsg').position().top);
      validateEditorTxt = 0;
    } else {
      $("#noofempValidMsg").hide();
    }

    var jobshadow_concert: any = "";

    $.each($("input[name='job_shadow']:checked"), function () {
      jobshadow_concert = $(this).val();
    });

    /*
    if(jobshadow_concert == ""){
      $("#jobshadow_concertValidMsg").show();
      $(window).scrollTop($('#jobshadow_concertValidMsg').position().top);
      validateEditorTxt = 0;
    }

    */

    var website: any = $('#websiteurl').val();
    var webregexvali = website_regex.test(website);
    if (website != "" && webregexvali == false) {
      $("#howtoapplyValidregex").show();
      $(window).scrollTop($('#howtoapplyValidregex').position().top);
      validateEditorTxt = 0;
    } else {
      $("#howtoapplyValidregex").hide();
    }

    if (categoriesArray.length <= 1) {
      $("#categoryValidMsg").show();
      $(window).scrollTop($('#categoryValidMsg').position().top);
      validateEditorTxt = 0;
    }
    else {
      $("#categoryValidMsg").hide();
    }

    if (companyProf == "") {
      $("#companyProfileValidMsg").show();
      $(window).scrollTop($('#companyProfileValidMsg').position().top);
      validateEditorTxt = 0;
    } else {
      $("#companyProfileValidMsg").hide();
    }

    if (validateEditorTxt == 0) {
      return false;
    }

    //console.log(categoriesArray);
    const categoryData = JSON.stringify(categoriesArray);
    console.log(categoryData);

    const str: any = $("#phone_number").val();
    const contactNumber = str.replace(/[^a-zA-Z0-9]/g, "")
    //const siteId =Math.floor(Math.random() * 10);.
    const siteId = "2";
    var accessTokenTov = sessionStorage.getItem("adminAccToken");
    const requestObject: any =
    {

      "siteId": "2",
      "firstName": $("#first_name").val(),
      "lastName": $("#last_name").val(),
      "email": $("#email_id").val(),

      "password": $("#password").val(),
      "isStudent": "No",

      "status": $("#approval_status").val(),
      "publicProfile": $("#public_profile").val(),
      "hasAccessToResume": $("#view_resumes").val(),
      "hasAccessToJobPosting": $("#hasAccessToJobPosting").val(),

      "name": $("#company_name").val(),
      "address1": $("#address_1").val(),
      "address2": $("#address_2").val(),
      "city": $("#city").val(),
      "state": $("#state").val(),
      "zip": $("#postalcode").val(),
      "countyId": $("#country").val(),
      "phone": $("#phone_number").val(),
      "employeeCount": $("#noofemp").val(),
      "webSite": $("#websiteurl").val(),
      "companyCategory": categoriesArray,
      "description": companyProf,
      "logourl": "",
      "videourl": "",



    }

    if (jobshadow_concert != "") {
      requestObject.jobShadowConcert = jobshadow_concert;
    }

    console.log(JSON.stringify(requestObject));

    var accessTokenIn = sessionStorage.getItem("adminAccToken");
    const requestOptions = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': "Bearer "+accessTokenIn 
        //'Authorization': accessTokenIn 
      },
      body: JSON.stringify(requestObject)
    };

    services.adminRegisterCompany(requestOptions).then((res) => {
      if (res.code == '200') {
        $("#addcompanysuccessMessage").fadeTo(2000, 500).slideUp(500, function () {
          $("#addcompanysuccessMessage").slideUp(500);
        });
        setTimeout(() => {
          history.push('/companydirectory');
        }, 1000);
      }
      else {
        $("#addcompanyfailMessage").fadeTo(2000, 500).slideUp(500, function () {
          $("#addcompanyfailMessage").slideUp(500);
        });
        setTimeout(() => {

        }, 1000);
      }
    });




    // return false; 
  }

  useEffect(() => {

    validateCheck();
    $(".se-dialog-tabs").hide();
    $("#jobshadow_concertValidMsg").hide();
    $('#addcompanysuccessMessage').hide();
    $('#addcompanyfailMessage').hide();
    $("#companyProfileValidMsg").hide();
    // $('#phone_number').usPhoneFormat();
    //<any>$("#phone_number").usPhoneFormat();
    ($('#phone_number') as any).usPhoneFormat();

    $("#companystatusValidMsg").hide();
    $("#firstNameValidMsg").hide();
    $("#lastNameValidMsg").hide();
    $("#passwordValidMsg").hide();
    $("#matchValidMsg").hide();
    $("#confpasswordValidMsg").hide();
    $("#emailValidMsg").hide();
    $("#companyNameValidMsg").hide();
    $("#addressValidMsg").hide();
    $("#cityValidMsg").hide();
    $('#zipcodeValidMsg').hide();
    $("#stateValidMsg").hide();
    $("#countyValidMsg").hide();
    $("#noofempValidMsg").hide();
    $("#howtoapplyValidregex").hide();
    $('#phonevalidmsg').hide();
    $("#categoryValidMsg").hide();
    $("#confpasswrdreqMsg").hide();
    $("#passwordReqMsg").hide();
    $('#emailReqMsg').hide();

    services.getIndustryData().then((res: any) => {
      //console.log("count"+res);
      setCategory(res.data.content);
    })
    services.getLocationCounty().then((res: any) => {
      //console.log("getLocationCounty data=" + JSON.stringify(res.data));
      setLocationCounty(res.data.content);
    });
    var statesJson: any = [{ "stateId": 4, "stateName": "Alabama", "stateCode": "AL" }, { "stateId": 5, "stateName": "Alaska", "stateCode": "AK" }, { "stateId": 6, "stateName": "Alabama", "stateCode": "AL" }, { "stateId": 7, "stateName": "Arizona", "stateCode": "AZ" }, { "stateId": 8, "stateName": "Arkansas", "stateCode": "AR" }, { "stateId": 9, "stateName": "California", "stateCode": "CA" }, { "stateId": 10, "stateName": "Colorado", "stateCode": "CO" }, { "stateId": 11, "stateName": "Connecticut", "stateCode": "CT" }, { "stateId": 12, "stateName": "Delaware", "stateCode": "DE" }, { "stateId": 13, "stateName": "District of Columbia", "stateCode": "DC" }, { "stateId": 14, "stateName": "Florida", "stateCode": "FL" }, { "stateId": 15, "stateName": "Georgia", "stateCode": "GA" }, { "stateId": 16, "stateName": "Hawaii", "stateCode": "HI" }, { "stateId": 17, "stateName": "Idaho", "stateCode": "ID" }, { "stateId": 18, "stateName": "Illinois", "stateCode": "IL" }, { "stateId": 19, "stateName": "Indiana", "stateCode": "IN" }, { "stateId": 20, "stateName": "Iowa", "stateCode": "IA" }, { "stateId": 21, "stateName": "Kansas", "stateCode": "KS" }, { "stateId": 22, "stateName": "Kentucky", "stateCode": "KY" }, { "stateId": 23, "stateName": "Louisiana", "stateCode": "LA" }, { "stateId": 24, "stateName": "Maine", "stateCode": "ME" }, { "stateId": 25, "stateName": "Maryland", "stateCode": "MD" }, { "stateId": 26, "stateName": "Massachusetts", "stateCode": "MA" }, { "stateId": 27, "stateName": "Michigan", "stateCode": "MI" }, { "stateId": 28, "stateName": "Minnesota", "stateCode": "MN" }, { "stateId": 29, "stateName": "Mississippi", "stateCode": "MS" }, { "stateId": 30, "stateName": "Missouri", "stateCode": "MO" }, { "stateId": 31, "stateName": "Montana", "stateCode": "MT" }, { "stateId": 32, "stateName": "Nebraska", "stateCode": "NE" }, { "stateId": 33, "stateName": "Nevada", "stateCode": "NV" }, { "stateId": 34, "stateName": "New Hampshire", "stateCode": "NH" }, { "stateId": 35, "stateName": "New Jersey", "stateCode": "NJ" }, { "stateId": 36, "stateName": "New Mexico", "stateCode": "NM" }, { "stateId": 37, "stateName": "New York", "stateCode": "NY" }, { "stateId": 38, "stateName": "North Carolina", "stateCode": "NC" }, { "stateId": 39, "stateName": "North Dakota", "stateCode": "ND" }, { "stateId": 40, "stateName": "Ohio", "stateCode": "OH" }, { "stateId": 41, "stateName": "Oklahoma", "stateCode": "OK" }, { "stateId": 42, "stateName": "Oregon", "stateCode": "OR" }, { "stateId": 43, "stateName": "Pennsylvania", "stateCode": "PA" }, { "stateId": 44, "stateName": "Puerto Rico", "stateCode": "PR" }, { "stateId": 45, "stateName": "Rhode Island", "stateCode": "RI" }, { "stateId": 46, "stateName": "South Carolina", "stateCode": "SC" }, { "stateId": 47, "stateName": "South Dakota", "stateCode": "SD" }, { "stateId": 48, "stateName": "Tennessee", "stateCode": "TN" }, { "stateId": 49, "stateName": "Texas", "stateCode": "TX" }, { "stateId": 50, "stateName": "Utah", "stateCode": "UT" }, { "stateId": 51, "stateName": "Vermont", "stateCode": "VT" }, { "stateId": 52, "stateName": "Virginia", "stateCode": "VA" }, { "stateId": 53, "stateName": "Washington", "stateCode": "WA" }, { "stateId": 54, "stateName": "West Virginia", "stateCode": "WV" }, { "stateId": 55, "stateName": "Wisconsin", "stateCode": "WI" }, { "stateId": 56, "stateName": "Wyoming", "stateCode": "WY" }];
    setStateData(statesJson);
  }, []);
  return (
    <>
      <PageTitle breadcrumbs={[]}>Register Company</PageTitle>
      <form onSubmit={handleSubmit(submitValue)}>
        <div className="container">
          <div className="row">

            <div className="col-lg-12">
              <div className="mb-10">

                <div className="d-flex flex-column ">
                  <label className=" required form-label">Status</label>
                  <small className="mb-3">Overall Approval Status</small>
                </div>
                <select id="approval_status" name="approval_status" className="form-select" aria-label="Select example">
                  <option selected value="published">Published</option>
                  <option value="pending">pending</option>


                </select>
                <div id="companystatusValidMsg" style={{ color: red }} className="error">Approval Status is required.</div>
              </div>
            </div>

            <div className="col-lg-6">
              <div className="mb-10">
                <div className="d-flex flex-column ">
                  <label className=" form-label">Public Profile?</label>

                </div>
                <select id="public_profile" name="public_profile" className="form-select" aria-label="Select example">
                  <option selected value="yes">Yes</option>
                  <option value="no">No</option>

                </select>
              </div>
            </div>

            <div className="col-lg-6">
              <div className="mb-10">
                <div className="d-flex flex-column ">
                  <label className="form-label">View Resumes?</label>

                </div>
                <select id="view_resumes" name="view_resumes" className="form-select" aria-label="Select example">
                  <option selected value="yes">Yes</option>
                  <option value="no">No</option>

                </select>
              </div>
            </div>


            <div className="col-lg-6">
              <div className="mb-10">
                <div className="d-flex flex-column ">
                  <label className="form-label">Has access to Job Posting?</label>

                </div>
                <select id="hasAccessToJobPosting" name="hasAccessToJobPosting" className="form-select" aria-label="Select example">
                  <option selected value="yes">Yes</option>
                  <option value="no">No</option>

                </select>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="mb-10">
              </div></div>

            <div className="col-lg-6">
              <div className="mb-10">
                <div className="d-flex flex-column ">
                  <label htmlFor="exampleFormControlInput1" className=" required form-label">First Name</label>

                </div>
                <input type="text" id="first_name" name="first_name" className="form-control" placeholder="" />

                <div id="firstNameValidMsg" style={{ color: red }} className="error">First Name is required.</div>
              </div>
            </div>


            <div className="col-lg-6">
              <div className="mb-10">
                <div className="d-flex flex-column ">
                  <label htmlFor="exampleFormControlInput1" className=" required form-label">Last Name</label>

                </div>
                <input type="text" id="last_name" name="last_name" className="form-control" placeholder="" />
                <div id="lastNameValidMsg" style={{ color: red }} className="error">Last Name is required.</div>
              </div>
            </div>

            <div className="col-lg-6">
              <div className="mb-10">
                <div className="d-flex flex-column ">
                  <label htmlFor="exampleFormControlInput1" className=" required form-label">Password</label>
                  <small className="mb-3">Minimum of 8 characters long, and a combination of lowercase & uppercase letters, numbers, and special characters.</small>
                </div>
                <input type="password" id="password" name="password" className="form-control" placeholder="" />


                <div id="passwordReqMsg" style={{ color: red }} className="error">Password is Required.</div>

                <div id="passwordValidMsg" style={{ color: red }} className="error">Password contain uppercase,lowercase and special character.</div>
                {/* {...register("Password", {
                                    required: "Password is required.",
                                    pattern: {
                                      value: /^(?=.*\d)(?=.*[!@#$%^&*])(?=.*[a-z])(?=.*[A-Z]).{8,}$/,
                                      message: "Password contain uppercase,lowercase and special character"
                                    },
                                    minLength: { value: 8, message: 'Too short' }
                                    })} 
                                 <ErrorMessage
                                    errors={errors}
                                    name="Password"
                                    class="invalid-feedback"
                                    render={({ messages }) => {
                                    console.log("messages", messages);
                                    return messages
                                        ? Object.entries(messages).map(([type, message]) => (
                                            <p style={{color:red}}  className="error">{message}</p>
                                        ))
                                        : null;
                                    }}
                                />*/}
              </div>
            </div>


            <div className="col-lg-6">
              <div className="mb-10">
                <div className="d-flex flex-column ">
                  <label htmlFor="exampleFormControlInput1" className=" required form-label">Confirm Password</label>
                  <small className="mb-3">Minimum of 8 characters long, and a combination of lowercase & uppercase letters, numbers, and special characters.</small>
                </div>
                <input type="password" id="conf_password" name="conf_password" className="form-control" placeholder="" />

                <div id="confpasswrdreqMsg" style={{ color: red }} className="error">Confirm Password is Required.</div>

                <div id="confpasswordValidMsg" style={{ color: red }} className="error">Password contain uppercase,lowercase and special character.</div>

                <div id="matchValidMsg" style={{ color: red }} className="error">Confirm Password should match with Password.</div>

              </div>
            </div>


            <div className="col-lg-6">
              <div className="mb-10">
                <div className="d-flex flex-column ">
                  <label className="required form-label">Email</label>
                  <small className="mb-3">Must be valid for notification</small>
                </div>
                <input type="text" id="email_id" name="email_id" className="form-control" placeholder="" />
                {/* onChange={e => setFieldName(e.target.value)} {...register("Email", {
                          required: "Email is required.",

                          pattern: {
                            value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                            message: "invalid email address"
                          }
                        })} */}
                <div id="emailReqMsg" style={{ color: red }} className="error">Email Address is required.</div>

                <div id="emailValidMsg" style={{ color: red }} className="error">Invalid email address.</div>
              </div>
            </div>


            <div className="col-lg-12">
              <div className="mb-10">
                <div className="d-flex flex-column ">
                  <label htmlFor="exampleFormControlInput1" className="required form-label">Company Name</label>

                </div>
                <input type="text" id="company_name" name="company_name" className="form-control" placeholder="" />
                <div id="companyNameValidMsg" style={{ color: red }} className="error">Company Name is required.</div>
              </div>
            </div>

            <div className="col-lg-6">
              <div className="mb-10">
                <div className="d-flex flex-column ">
                  <label htmlFor="exampleFormControlInput1" className=" required form-label">Address</label>

                </div>
                <input type="text" id="address_1" name="address_1" className="form-control" placeholder="" />

                <div id="addressValidMsg" style={{ color: red }} className="error">Address is required.</div>
              </div>
            </div>

            <div className="col-lg-6">
              <div className="mb-10">
                <div className="d-flex flex-column ">
                  <label htmlFor="exampleFormControlInput1" className="  form-label">Address 2</label>

                </div>
                <input type="text" id="address_2" name="address_2" className="form-control" placeholder="" />
              </div>
            </div>

            <div className="col-lg-6">
              <div className="mb-10">
                <div className="d-flex flex-column ">
                  <label htmlFor="exampleFormControlInput1" className="required form-label">City</label>

                </div>
                <input type="text" id="city" name="city" className="form-control" />
                <div id="cityValidMsg" style={{ color: red }} className="error">City is required.</div>
              </div>
            </div>

            <div className="col-lg-6">
              <div className="mb-10">
                <div className="d-flex flex-column ">
                  <label htmlFor="exampleFormControlInput1" className=" required form-label">State</label>

                </div>
                <select id="state" name="state" className="form-select" aria-label="Select example" >
                  <option selected value="" >Select State</option>
                  {
                    stateData.map((state, index) => (
                      <option value={state.stateCode}>{state.stateName}</option>
                    ))
                  }
                </select>
                <div id="stateValidMsg" style={{ color: red }} className="error">State is required.</div>
              </div>
            </div>

            <div className="col-lg-6">
              <div className="mb-10">
                <div className="d-flex flex-column ">
                  <label htmlFor="exampleFormControlInput1" className="required form-label">Zipcode</label>

                </div>
                <input type="text" id="postalcode" name="postalcode" className="form-control" placeholder="" />
                <div id="zipcodeValidMsg" style={{ color: red }} className="error">Zipcode is required.</div>
              </div>
            </div>

            <div className="col-lg-6">
              <div className="mb-10">
                <div className="d-flex flex-column ">
                  <label htmlFor="exampleFormControlInput1" className=" form-label">County</label>

                </div>
                <select id="country" name="country" className="form-select" aria-label="Select example" >
                  <option selected value="" >Select County</option>
                  {
                    locationCounty.map((data, index) => (
                      <option value={data.jobLocationCountyId} >{data.name}</option>
                    ))}
                </select>
                <div id="countyValidMsg" style={{ color: red }} className="error">County is required.</div>
              </div>
            </div>

            <div className="col-lg-6">
              <div className="mb-10">
                <div className="d-flex flex-column ">
                  <label htmlFor="exampleFormControlInput1" className="required form-label">Phone </label>
                  {/* <small className="mb-3">xxx-xxx-xxxx</small> */}
                </div>
                <input type="text" id="phone_number" name="phone_number" className="form-control" placeholder="" />
                <div id="phonevalidmsg" style={{ color: red }} className="error">Phone Number is required.</div>
              </div>
            </div>

            <div className="col-lg-6">
              <div className="mb-10">
                <div className="d-flex flex-column ">
                  <label htmlFor="exampleFormControlInput1" className="required form-label">No of Employees</label>

                </div>
                <input type="text" id="noofemp" name="noofemp" className="form-control" placeholder="" />
                <div id="noofempValidMsg" style={{ color: red }} className="error">No of Employees is required.</div>
              </div>
            </div>

            <div className="col-lg-12">
              <div className="mb-10">
                <div className="d-flex flex-column ">
                  <label htmlFor="exampleFormControlInput1" className=" form-label">Website</label>
                  <small>Example: http://example.com</small>

                </div>
                <input type="text" id="websiteurl" name="websiteurl" className="form-control" placeholder="" />
                <div id="howtoapplyValidregex" style={{ color: red }} className="error">Please enter valid website URL.</div>
              </div>

            </div>

            <div className="col-lg-12">
              <div className="mb-10">
                <div className="d-flex flex-column ">
                  <label htmlFor="exampleFormControlInput1" className="required form-label">Company Profile</label>
                </div>
                {/*} <h1>this is FCK editor area</h1>*/}
                {/* <CKEditor
                  editor={ClassicEditor}
                  config={{
                    removePlugins: ["EasyImage","ImageUpload","MediaEmbed"]
                  }}
                  id="companyProfileId"
                  onReady={editor => {
                    // You can store the "editor" and use when it is needed.
                    console.log('Editor is ready to use!', editor);
                    //editor.setData(profileDescription);
                    //editor.setData(profileDescription);

                  }}
                  onChange={(event, editor) => {
                    const data = editor.getData();
                    setCompanyProfile(data);
                    console.log({ event, editor, data });
                  }}
                  onBlur={(event, editor) => {
                    console.log('Blur.', editor);
                  }}
                  onFocus={(event, editor) => {
                    console.log('Focus.', editor);
                  }}
                /> */}

                <SunEditor
                  setOptions={{
                    height: "400",
                    //buttonList: [['font', 'align'], ['image']]
                    buttonList: [
                      ['undo', 'redo'],
                      ['font', 'fontSize', 'formatBlock'],
                      ['paragraphStyle', 'blockquote'],
                      ['bold', 'underline', 'italic', 'strike', 'subscript', 'superscript'],
                      ['fontColor', 'hiliteColor', 'textStyle'],
                      ['removeFormat'],
                      '/', // Line break
                      ['outdent', 'indent'],
                      ['align', 'horizontalRule', 'list', 'lineHeight'],
                      ['table', 'link', 'image' /** ,'math' */], // You must add the 'katex' library at options to use the 'math' plugin.                    
                      ['fullScreen', 'showBlocks', 'codeView'],
                      ['preview'],

                      /** ['dir', 'dir_ltr', 'dir_rtl'] */ // "dir": Toggle text direction, "dir_ltr": Right to Left, "dir_rtl": Left to Right
                    ]
                    //buttonList: buttonList.complex
                    // plugins: [font] set plugins, all plugins are set by default
                    // Other option
                  }}
                  onChange={handleChangeCompanyProfileDesc}
                  onImageUploadBefore={handleImageUploadBefore}
                />


                <div id="companyProfileValidMsg" style={{ color: red }} className="error">Company Profile is required.</div>
                {/*<textarea id="careers" cols="30" rows="10"  style={{maxHeight: 75, minWidth: '100%'}} {...register("companyprofile", {
                          required: "This field is required",
                          maxLength: { value: 2000, message: 'Should not allow more than 2000 character' }
                        })}></textarea>
                        	<ErrorMessage
                          errors={errors}
                          name="companyprofile"
                          class="invalid-feedback"
                          render={({ messages }) => {
                            console.log("messages", messages);
                            return messages
                              ? Object.entries(messages).map(([type, message]) => (
                                <p key={type} class="error">{message}</p>
                              ))
                              : null;
                          }}

                        />*/}
              </div>
            </div>
            <div className="col-lg-12">
              <div className="mb-10">
                <div className="d-flex flex-column ">
                  <label htmlFor="exampleFormControlInput1" className="required form-label">Company Industry</label>
                  <small>Max 3 Categories</small>
                  <div className="row mt-8">


                    {/* <ul  class="col-md-12 mb-4">
                        {
                          categories.map((category, index) => (                                            
                           <li class="form-check form-check-custom form-check-solid my-2"><input class="form-check-input" type="checkbox" value={category.catId} name="category" id="category" {...register('category', { required: true })} onClick={()=>validateCheck()}/>  <label class="form-check-label" htmlFor="defaultCheck1"> {category.name} </label></li>
                        ))
                        }
                           
                        </ul> */}

                    <div className="row">
                      {
                        categories.map((category, index) => (
                          <div className=" col-md-6 form-check form-check-custom form-check-solid my-2 "><input className="form-check-input" type="checkbox" value={category.catId} name="categorylist" id="categorylist" onClick={() => validateCheck()} />  <label className="form-check-label" htmlFor="defaultCheck1"> {category.name} </label></div>
                        ))
                      }

                    </div>

                    <div id="categoryValidMsg" style={{ color: red }} className="error">Please Check at least 1 Category.</div>



                  </div>
                </div>

              </div>
            </div>



            <div className="col-lg-12">
              <div className="mb-10">
                <div className="d-flex flex-column ">
                  <label htmlFor="exampleFormControlInput1" className=" form-label">Does your company provide Job Shadow opportunities?</label>
                </div>


                <input className="form-check-input" type="radio" value="Y" name="job_shadow" id="job_shadow_y" />  <label className="form-check-label" htmlFor="defaultCheck1"> Yes </label> &nbsp; &nbsp;
                <input className="form-check-input" type="radio" value="N" name="job_shadow" id="job_shadow_n" />  <label className="form-check-label" htmlFor="defaultCheck1"> No </label>


                <div id="jobshadow_concertValidMsg" style={{ color: red }} className="error">This field is required.</div>




                <div className="divider"></div>

                <button type="submit" className="btn btn-primary mt-10" style={{ maxWidth: "200px" }}> Create Company </button>


                <div id="addcompanysuccessMessage" className="alert alert-success" role="alert">Company Created Successfully</div>
                <div id="addcompanyfailMessage" className="alert alert-danger" role="alert">Please try again</div>




              </div>
            </div>




          </div>
        </div>
      </form>
    </>
  )
}
export { CreateCompany }